import cn from 'classnames'

import { useCallback, useEffect, useState } from 'react'

import dynamic from 'next/dynamic'

import { useRouter } from 'next/router'

import ButtonBlue from '../../../../components/ui/button/_color/_blue'

import { useAppSelector } from '../../../../store/hooks'

import { LoginStatuses, selectedAuthStatus } from '../../../../store/reducers/users'

import styles from './styles.module.scss'

import HeaderBtcLogo from './images/header-btc-logo.svg'
import CoinLogoImage from './images/coinLogoImage.png'
import CoinLogoImageMobile from './images/coinLogoImage-mobile.png'
import { useTranslation } from 'utils/use-translation'

const LoginForm = dynamic(() => import('../../../../components/ui/header/components/popup-login-form'), { ssr: false })

const POPUP_TYPE_LOANS = 'loans'

export default function CoinWalletHeader({ pageCurrency }) {
  const { t, locale } = useTranslation()
  const [isOpenLoginBlock, setIsOpenLoginBlock] = useState(false)

  const authStatus = useAppSelector(selectedAuthStatus)
  const router = useRouter()

  const handleClosePopup = useCallback(() => {
    setIsOpenLoginBlock(false)
  }, [])

  const [windowWidth, setWindowWidth] = useState<number>(0)

  useEffect(() => {
    if (window) {
      setWindowWidth(window.innerWidth)
    }
  }, [])

  const goToWallets = async () => {
    if (authStatus === LoginStatuses.LOGIN) {
      await router.push({
        pathname: '/account/wallets',
      })
    } else {
      setIsOpenLoginBlock(true)
    }
  }

  return (
    <section className={styles.header}>
      <div className={styles.header__content}>
        <div className={styles.header__content__title}>
          <h1>
            {t('best')} {pageCurrency.name} ({pageCurrency.ticker}) {t('wallet')}
            {windowWidth < 765 ? <br /> : <></>}
            &nbsp;{t('to')}&nbsp;
            <br />
            <span className={styles.dn}>{t('borrow_lend_swap')}</span>
            <span className={cn(styles.animate, styles.animate_1)} data-lang={locale}></span>
          </h1>
        </div>
        <p>{pageCurrency.subtitle}</p>
        <ButtonBlue onClick={goToWallets} className={styles.header__content__btn} bordered>{t('create_wallet')}</ButtonBlue>
      </div>

      <div className={styles.header__image}>
        <img
          className={styles.header__image__bg}
          src={windowWidth > 765 ? CoinLogoImage : CoinLogoImageMobile}
          alt="coin logo background"
        />
        <img
          className={styles.header__image__coin}
          src={pageCurrency.headerLogoUrl || HeaderBtcLogo}
          alt="coin logo image"
        />
      </div>
      {isOpenLoginBlock && <LoginForm isWallet={false} onCloseForm={handleClosePopup} type={POPUP_TYPE_LOANS} />}
    </section>
  )
}
